import { DefaultTheme } from 'styled-components';

import colors from './colors';
import text from './text';

const base = 16;

const dimensions = {
  bigMargin: base * 2,
  margin: base * 1,
  gutter: base * 0.5,
  spacing: base * 0.25,
  thin: base * 0.125,

  buttonNormalHeight: base * 3,
  buttonSmallHeight: base * 2.75,
  buttonSubHeight: base * 2.375,

  valueButtonHeight: base * 2.25,
  valueButtonPadding: base * 0.46875,

  listDefaultPadding: base,
};

export interface FrismTheme extends DefaultTheme {
  colors: typeof colors;
  dimensions: typeof dimensions;
  text: typeof text;
}

const normalTheme: FrismTheme = {
  colors,
  dimensions,
  text,
};

export default normalTheme;
